import React from "react";

interface HeaderProps {
  tableData: any;
}

const QuestionsViewDetails: React.FC<HeaderProps> = ({ tableData }) => {
  return (
    <div className="">
      <div className="columns is-multiline">
        <div className="column is-12">
          <strong>Questions (English)</strong>
        </div>
        <div className="column is-12">{tableData?.ques_en}</div>
        <div className="column is-12">
          <strong>Questions (Hindi)</strong>
        </div>
        <div className="column is-12">{tableData?.ques_hi}</div>
      </div>

      <table className="table is-fullwidth">
        <thead>
          <tr>
            <th>S.No</th>
            <th>Option (English)</th>
            <th>Option (Hindi)</th>
          </tr>
        </thead>
        <tbody>
          {tableData?.sub_data?.map((item: any, index: number) => {
            const isCorrect = tableData?.correct_option === index + 1;
            return (
              <tr
                key={index}
                className={isCorrect ? "has-background-success has-text-white" : ""}
              >
                <td>{index + 1}.</td>
                <td>{item.option_en}</td>
                <td>{item.option_hi}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="columns is-multiline">
        <div className="column is-3 has-text-centered">
          <strong>Select Answer Option:</strong>
        </div>
        <div className="column is-3">{tableData?.correct_option}</div>
      </div>
    </div>
  );
};

export default QuestionsViewDetails;
